module.exports = __webpack_public_path__ + "img/roast_logo.2a87225e.svg";